__turbopack_context__.v({
  "body": "innovation-investor-module-scss-module__1LpSHW__body",
  "container": "innovation-investor-module-scss-module__1LpSHW__container",
  "divider": "innovation-investor-module-scss-module__1LpSHW__divider",
  "eyebrow": "innovation-investor-module-scss-module__1LpSHW__eyebrow",
  "grid": "innovation-investor-module-scss-module__1LpSHW__grid",
  "heading": "innovation-investor-module-scss-module__1LpSHW__heading",
  "learnMore": "innovation-investor-module-scss-module__1LpSHW__learnMore",
  "left": "innovation-investor-module-scss-module__1LpSHW__left",
  "right": "innovation-investor-module-scss-module__1LpSHW__right",
  "row": "innovation-investor-module-scss-module__1LpSHW__row",
  "rowArrow": "innovation-investor-module-scss-module__1LpSHW__rowArrow",
  "rowBody": "innovation-investor-module-scss-module__1LpSHW__rowBody",
  "rowFigure": "innovation-investor-module-scss-module__1LpSHW__rowFigure",
  "rowSub": "innovation-investor-module-scss-module__1LpSHW__rowSub",
  "rowTag": "innovation-investor-module-scss-module__1LpSHW__rowTag",
  "rowTitle": "innovation-investor-module-scss-module__1LpSHW__rowTitle",
  "rowsHead": "innovation-investor-module-scss-module__1LpSHW__rowsHead",
  "section": "innovation-investor-module-scss-module__1LpSHW__section",
});
